<template>
  <div>
    <v-layout wrap v-if="shipmentLabel.type">
      <span class="font-weight-bold">{{ $t('type') }}:&nbsp; </span>{{ shipmentLabel.type }}
    </v-layout>
    <v-layout wrap v-if="shipmentLabel.orderId">
      <v-flex class="text-xs-left"
        ><span class="font-weight-bold">ID:&nbsp; </span>
        <span> {{ shipmentLabel._key }}</span>
       </v-flex
      >
      <v-flex v-if="isSingleFile || isFedexMWT">
        <span @click.stop="showDetailTable" :style="{cursor: 'pointer', color: '#64B5F6'}" class="more-info-text">
          {{ $t('moreInfo') }}
        </span>
      </v-flex>
      <v-flex v-if="$store.getters.user.isAdmin" class="text-xs-right">[{{ index + 1 }}]</v-flex>
    </v-layout>
    <v-layout wrap v-else-if="shipmentLabel.labelTaskKey">
      <v-flex class="text-xs-left"
        ><span class="font-weight-bold">ID:&nbsp; </span>
        <span> {{ shipmentLabel.requestId }}</span>
       </v-flex
      >
    </v-layout>
    <v-layout wrap v-if="shipmentLabel.shipmentId">
      <span class="font-weight-bold">{{ $t('shipmentID') }}:&nbsp; </span>
      {{ shipmentLabel.shipmentId }}
    </v-layout>
    <v-layout wrap v-if="shipmentLabel.itn">
      <span class="font-weight-bold">ITN:&nbsp; </span> {{ shipmentLabel.itn }}
    </v-layout>
    <v-layout>
      <v-flex md5 v-if="shipmentLabel.packages.length">
        <span class="font-weight-bold">{{ $t('totalPkgQty') }}: </span>
        {{ isFedexMWT ? shipmentLabel.packages.reduce((sum, label) => sum += (label.qty || 1), 0) : shipmentLabel.packages.length }}
      </v-flex>
      <v-flex md1></v-flex>
      <v-flex md6 v-if="shipmentLabel.weight">
        <span class="font-weight-bold">{{ $t('totalWeight') }}: </span> {{ shipmentLabelWeight }}
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex
        md6
        v-if="
          shipmentLabel.pricingOption === PRICING_OPTIONS.ONE_RATE
        "
      >
        <span class="font-weight-bold">{{ $t('packageType') }}: </span>
        {{ shipmentLabel.packageType }}
      </v-flex>
      <v-flex
        md6
        v-else-if="
          shipmentLabel.packaging && JSON.stringify(shipmentLabel.packaging) !== '{}'
        "
      >
        <span class="font-weight-bold">{{ $t('Size(L/W/H)') }}: </span>
        {{ displayPackaging(shipmentLabel.packages[0]) }}
      </v-flex>
      <v-flex md1></v-flex>
    </v-layout>
    <v-layout>
      <span class="font-weight-bold text-capitalize"
        >{{ $t('declaredValue') }}:&nbsp;
      </span>
      {{ shipmentLabel.insuredValue }}
    </v-layout>
    <v-layout v-if="shipmentLabel.signature">
      <span class="font-weight-bold text-capitalize">{{ $t('signature') }}:&nbsp; </span>
      {{ shipmentLabel.signature }}
    </v-layout>
    <v-layout v-if="isSupportSaturdayDelivery">
      <span class="font-weight-bold text-capitalize">{{ $t('supportSaturdayDelivery') }}</span>
    </v-layout>
    <v-layout wrap v-if="shipmentLabel.memo || shipmentLabel.packages[0].memo">
      <span class="font-weight-bold">{{ $t('memo') }}:&nbsp; </span>{{ shipmentLabel.packages[0].memo || shipmentLabel.memo }}
    </v-layout>

    <v-layout v-if="shipmentLabel.isSupportHazmat || shipmentLabel.dangerousGoods">
      <v-flex md7>
        <span class="font-weight-bold">{{ $t('dangerousGoods') }}: </span>
        {{ dangerousGoodsLabel }}
      </v-flex>
      <template v-if="isBattery">
        <span @click.stop="showDangerousGoodsDetailTable" :style="{cursor: 'pointer'}">
          <v-icon small color="blue">info</v-icon>
        </span>
      </template>
    </v-layout>

     <v-layout
      wrap
      v-if="shipmentLabel.note"
      style="overflow-wrap: break-word; word-break: break-all"
    >
      <span class="font-weight-bold">{{ $t('note') }}:&nbsp; </span>{{ shipmentLabel.note }}
    </v-layout>
     <v-layout
      wrap
      v-if="shipmentLabel.reference"
      style="overflow-wrap: break-word; word-break: break-all"
    >
      <span class="font-weight-bold">{{ $t('reference') }}:&nbsp; </span>{{ shipmentLabel.reference }}
    </v-layout>
    <v-layout wrap v-if="$store.getters.user.isAdmin && shipmentLabel.clientName">
      <span class="font-weight-bold">{{ $t('client') }}:&nbsp; </span
      >{{ shipmentLabel.clientName }}
    </v-layout>
    <v-layout wrap v-if="shipmentLabel.orderKey">
      <span class="font-weight-bold">{{ $t('orderKey') }}:&nbsp; </span
      >{{ orderKey }}
    </v-layout>

    <LabelDetailPopup
      v-if="detailToggle"
      v-model="detailToggle"
      :shipmentLabel="shipmentLabel"
      :isFedexMWT="isFedexMWT"
      :isSingleFile="isSingleFile"
    />

    <FormSubmitPopup
      :title="$t('hazMatsInfoDetail')"
      v-model="showBatteryDetailDialog"
      v-if="showBatteryDetailDialog"
      medium
      @popupClose="showBatteryDetailDialog = false"
      hideRgtBtn
    >
      <template v-slot:input>
        <HazardousCommodities
          :value="shipmentLabel.hazMatsInfo"
          :dangerousGoods="shipmentLabel.dangerousGoods"
          :offerorName="shipmentLabel.offerorName"
          :emergencyContactNumber="shipmentLabel.emergencyContactNumber"
          readonly
        />
      </template>
    </FormSubmitPopup>
  </div>
</template>

<script>
import { PRICING_OPTIONS } from '@/utils/const'
import FormSubmitPopup from './FormSubmitPopup'
import HazardousCommodities from './HazardousCommodities'
import LabelDetailPopup from './LabelDetailPopup'

export default {
  name: 'LabelDetailWidget',
  components: {
    FormSubmitPopup,
    HazardousCommodities,
    LabelDetailPopup
  },
  data () {
    return {
      detailToggle: false,
      showBatteryDetailDialog: false,
      PRICING_OPTIONS
    }
  },
  methods: {
    displayPackaging (packaging) {
      let {length, width, height, isMeasurementMetric, originLength, originWidth, originHeight} = packaging || {}
      const { pricingOption, packageType } = this.shipmentLabel
      if (pricingOption === PRICING_OPTIONS.ONE_RATE) {
        return packageType
      }
      return isMeasurementMetric ? `${originLength || length}cm/${originWidth || width}cm/${originHeight || height}cm` : `${length || originLength}"/${width || originWidth}"/${height || originHeight}"`
    },
    showDetailTable () {
      if (!this.isSingleFile && !this.isFedexMWT) return

      this.detailToggle = true
    },
    showDangerousGoodsDetailTable () {
      this.showBatteryDetailDialog = true
    }
  },
  computed: {
    orderKey () {
      return this.shipmentLabel.orderKey
    },
    isFedexMWT () {
      const { carrier } = this.shipmentLabel
      return carrier === 'FEDEX-MWT'
    },
    shipmentLabelWeight () {
      const { pricingOption, packages, isMeasurementMetric } = this.shipmentLabel
      const isOneRate = pricingOption === PRICING_OPTIONS.ONE_RATE
      const unit = (isOneRate || !isMeasurementMetric) ? 'lbs' : 'kg'
      const weight = Math.ceil(packages.reduce(
        (sum, pkg) => {
          if (isOneRate) return sum + pkg.weight * (pkg.qty || 1)
          return sum + (isMeasurementMetric ? pkg.originWeight : pkg.weight) * (pkg.qty || 1)
        },
        0
      ))
      return weight + unit
    },
    labelServices () {
      return this.$store.getters.labelServices
    },
    isSupportSaturdayDelivery () {
      const { serviceType, isSaturdayDelivery } = this.shipmentLabel
      return this.labelServices.some(service => {
        const labelService = service.serviceTypes.find(type => type.value === serviceType)
        return labelService
          ? labelService.hasOwnProperty('isSaturdayDelivery')
            ? labelService.isSaturdayDelivery
            : service.isSaturdayDelivery
          : false
      }) && isSaturdayDelivery
    },
    isBattery () {
      return this.shipmentLabel.dangerousGoods === 'BATTERY'
    },
    dangerousGoodsLabel () {
      const dangerousGoodsMap = {
        BATTERY: 'battery',
        DRY_ICE: 'dryIce'
      }
      const dangerousGoodsLabel = this.$t(dangerousGoodsMap[this.shipmentLabel.dangerousGoods])
      return dangerousGoodsLabel
    },
    isSingleFile () {
      return this.shipmentLabel.isSingleFile !== undefined ?
        this.shipmentLabel.isSingleFile :
        ['UPS_CWT_EST', 'UPS_CWT_WST', 'UPS_CWT_CTR', 'UPS_SP_WST', 'UPS_SP_EST', 'KSAESP', 'KSAE', 'KSAWSP', 'KSAW', 'KSAG', 'KSAG2', 'KSAGSP', 'NEXTSLS'].includes(this.shipmentLabel.channel)
    }
  },
  props: {
    shipmentLabel: {
      type: Object,
      default: () => ({})
    },
    index: 0
  }
}
</script>

<style scoped>
.more-info-text {
  font-size: 0.875rem;
  font-weight: 500;
  user-select: none;
}

.more-info-text:hover {
  color: #42A5F5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/LabelDetailsWidget.vue